// extracted by mini-css-extract-plugin
export default {"spacer":"Profile_spacer__oHE9J"};